// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';
import { CommonService } from '../common/common.service';
import { BehaviorSubject } from 'rxjs';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { MasterConstants } from '../../common/constants/master-constants';
import { LolLoggerService } from '../../common/shared/lol-logger.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable()
export class QuoteOrderService {
  constructor(public configService: ConfigService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private networkService: NetworkService) {
    this.quoteId = new BehaviorSubject(0);
    this.cppOrderId = new BehaviorSubject(0);

    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }

  // quoteId in place of query string use quoteId in service
  quoteId: BehaviorSubject<number>;
  cppOrderId: BehaviorSubject<number>;

  private pdfDataObject: any;
  private ind: number;
  private isRedirectedFromPlacedOrder = false;
  plAccess = false;

  public setQuoteId(value: number) {
    this.quoteId.next(value);
  }
  public setCppOrderId(value: number) {
    this.cppOrderId.next(value);
  }

  // For View Quote details
  public getQuoteOrderDetail(quoteNumber) {
    return this.networkService.getRequest(this.configService.getQuoteOrderDetail() + '?quoteNumber=' + quoteNumber);
  }

  // For Approve or Reject quote
  public approveOrRejectQuote(quoteNumber, comments, status) {
    return this.networkService.getRequest(this.configService.approveOrRejectQuote() + '?quoteNumber=' + quoteNumber + '&comments=' + comments + '&status=' + status);
  }

  // For Close quote
  public closeQuote(quoteNumber) {
    return this.networkService.getRequest(this.configService.closeQuote() + '?quoteNumber=' + quoteNumber);
  }

  // submit sales order quote
  public submitSalesOrder(saveObj) {
    return this.networkService.postRequest(this.configService.submitSalesOrder(), saveObj);
  }

  // For View Quote summary
  public getQuoteOrderSummary(quoteId, cppOrderId) {
    return this.networkService.getRequest(this.configService.getQuoteOrderSummary() + '?quoteId=' + quoteId + '&cppOrderId=' + cppOrderId);
  }

  // get product for create page
  public getQuoteOrderProduct(quoteId) {
    return this.networkService.getRequest(this.configService.getQuoteOrderProduct() + '?quoteId=' + quoteId);
  }

  // check quote order tab access
  public checkQuoteOrderTabAccess() {
    return this.networkService.getRequest(this.configService.getQuoteOrderAccess());
  }

  // Get Quote Order Items List
  public quoteOrderItemsList(filters) {
    return this.networkService.postRequest(this.configService.getQuoteOrderItemsData(), filters);
  }

  // Get Quote Order Items List
  public quoteOrderItemsListExport(filters) {
    return this.networkService.postRequest(this.configService.getQuoteOrderItemsExportData(), filters);
  }

  // save quote order draft
  public saveQuoteOrderDraft(saveObj) {
    return this.networkService.postRequest(this.configService.saveQuoteOrderDraft(), saveObj);
  }

  // check Quote Existing Draft Order
  public checkQuoteExistingDraftOrder(accountNumber, quoteId) {
    return this.networkService.getRequest(this.configService.checkQuoteExistingDraftOrder() + '?accountNumber=' + accountNumber + '&quoteId=' + quoteId);
  }

  // For get the data for Quote Orders
  public getQuoteOrder(quoteId) {
    return this.networkService.getRequest(this.configService.getQuoteOrder() + '?quoteId=' + quoteId);
  }

  // send Quote Order Confirmation Email
  public sendQuoteOrderConfirmationEmail(emailObject) {
    return this.networkService.postRequest(this.configService.sendQuoteOrderConfirmationEmail(), emailObject);
  }

  // For View Quote summary pdf
  public getTestPDF() {
    return this.networkService.getRequest(this.configService.getTestPDF());
  }

  // test get pdf url from api
  public getNewTestPdf() {
    return this.networkService.getRequest(this.configService.getTestPdfUrlfromBaseFile());
  }

  // Generate Pdf report
  public generatePdf(pdfDataObject: any, isCPPPriceAccess: boolean) {
    if (pdfDataObject) {
      this.pdfDataObject = pdfDataObject;
      this.plAccess = isCPPPriceAccess;
      const documentDefinition = this.getDocumentDefinition();
      pdfMake.createPdf(documentDefinition).download('Quote_Order_' + this.commonService.GetTimeForFileName() + '.pdf');
    } else {
      for (let index = 0; index < this.pdfDataObject.cppOrders.length; index++) {
        this.toastrService.error('No data available for WebOrderNumber #' + this.pdfDataObject.cppOrders[index].webOrderNumber);
      }
    }
  }

  // PDF document defination
  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, MasterConstants.DATE_MMDDYYYY);
    // const orderCreateDate = this.pdfDataObject.cppOrders[0].createdOnString;
    let displayWith = [];
    // let columnList = [];
    // let valueList = [];

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [],
      pageBreakBefore: function (currentNode) {
        return currentNode.style && currentNode.style.indexOf('pageBreak') > -1;
      },
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
        tableUnit: {
          fontSize: 8,
          background: '#feeaa6',
          color: '#757575'
        },
        tablePayment: {
          fontSize: 8,
          background: '#b4e3df',
          color: '#757575'
        }
      }
    };

    // Push data inside content property - to repeat in PDF
    // Push only once(not repeated)
    pdfHTML.content.push(
      {
        image: 'data:image/png;base64,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',
        width: 102,
        height: 37,
        alignment: 'left',
      },
      {
        layout: 'noBorders',
        table: {
          widths: ['15%', '85%'],
          body: [
            ['QUOTE NUMBER:    ', this.pdfDataObject.quoteNumber.toString(),],
            ['ACCOUNT:', this.pdfDataObject.accountName + ' \n' +
              this.pdfDataObject.address + ' \n' + this.pdfDataObject.city + ', ' + this.pdfDataObject.state + ' ' + this.pdfDataObject.zipCode],
            ['QUOTE DATE:', this.datePipe.transform(this.pdfDataObject.quoteDate, 'MM/dd/yyyy')],
            ['CLOSE DATE:', this.datePipe.transform(this.pdfDataObject.closeDate, 'MM/dd/yyyy')],
          ]
        },
        style: 'pageText',
        fontSize: 8,
        marginTop: 10
      },
    );

    for (let i = 0; i < this.pdfDataObject.cppOrders.length; i++) {
      this.ind = i;

      // To show order details (repeated data)
      pdfHTML.content.push(
        {
          layout: 'noBorders',
          table: {
            widths: ['15%', '85%'],
            body: [
              ['ORDER NUMBER:', this.pdfDataObject.cppOrders[i].webOrderNumber.toString(),],
              ['CREATED:', this.datePipe.transform(this.pdfDataObject.cppOrders[i].createdOn, 'MM/dd/yyyy')],
              ['PLACED BY:', this.pdfDataObject.cppOrders[i].placedByName],
              ['CUSTOMER PO#:', this.pdfDataObject.cppOrders[i].custPONumber],
              // ['ACCOUNT NUMBER:', this.pdfDataObject.cppOrders[i].accountNumber],
            ]
          },
          style: 'pageText',
          fontSize: 8,
          marginTop: 10,
        }
      );

      // Ship-To, Sold-To & Deliver-To objects.
      const cppOrder_i = this.pdfDataObject.cppOrders[i];
      const deliverToAccountDetails = this.pdfDataObject.cppOrders[i].deliverToDetail;
      const soldToAccountDetails = this.pdfDataObject.cppOrders[i].soldToDetail;
      if (soldToAccountDetails) {
        soldToAccountDetails.address2 = soldToAccountDetails.address2.replace('<br>', '');
      }

      // ShipTo Account available
      if (deliverToAccountDetails == null && soldToAccountDetails == null) {
        displayWith = ['100%'];
        pdfHTML.content.push(
          {
            layout: 'noBorders',
            table: {
              widths: displayWith,
              body: [
                [{ text: 'SHIP TO: ' + cppOrder_i.accountNumber, bold: true }],
                [
                  cppOrder_i.accountName + ' \n' +
                  cppOrder_i.accountAddress1 + ' \n' +
                  cppOrder_i.accountCity + ', ' + cppOrder_i.accountState + ' ' + cppOrder_i.accountZipCode,
                ]
              ]
            },
            style: 'pageText',
            fontSize: 8,
            marginTop: 10,
          }
        );
      }
      // ShipTo & DeliverTo  Account Available
      else if (deliverToAccountDetails != null && soldToAccountDetails == null) {
        displayWith = ['50%', '50%'];
        pdfHTML.content.push(
          {
            layout: 'noBorders',
            table: {
              widths: displayWith,
              body: [
                [{ text: 'SHIP TO: ' + cppOrder_i.accountNumber, bold: true }, { text: 'DELIVER TO: ' + deliverToAccountDetails.accountNo, bold: true }],
                [
                  cppOrder_i.accountName + ' \n' +
                  cppOrder_i.accountAddress1 + ' \n' +
                  cppOrder_i.accountCity + ', ' + cppOrder_i.accountState + ' ' + cppOrder_i.accountZipCode,

                  deliverToAccountDetails.accountName + ' \n' +
                  deliverToAccountDetails.address1 + ' \n' +
                  deliverToAccountDetails.city + ', ' + deliverToAccountDetails.state + ' ' + deliverToAccountDetails.zipCode + ' \n',

                ]
              ]
            },
            style: 'pageText',
            fontSize: 8,
            marginTop: 10,
          }
        );
      }
      // ShipTo & SoldTo Account Available
      else if (deliverToAccountDetails == null && soldToAccountDetails != null) {
        displayWith = ['50%', '50%'];
        pdfHTML.content.push(
          {
            layout: 'noBorders',
            table: {
              widths: displayWith,
              body: [
                [{ text: 'SOLD TO: ' + soldToAccountDetails.accountNo, bold: true }, { text: 'SHIP TO: ' + cppOrder_i.accountNumber, bold: true }],
                [
                  soldToAccountDetails.accountName + ' \n' +
                  soldToAccountDetails.address1 + ' \n' +
                  (soldToAccountDetails.address2 == '' ? '' : soldToAccountDetails.address2 + ' \n') +
                  soldToAccountDetails.city + ', ' + soldToAccountDetails.state + ' ' + soldToAccountDetails.zipCode + ' \n',

                  cppOrder_i.accountName + ' \n' +
                  cppOrder_i.accountAddress1 + ' \n' +
                  cppOrder_i.accountCity + ', ' + cppOrder_i.accountState + ' ' + cppOrder_i.accountZipCode,
                ]
              ]
            },
            style: 'pageText',
            fontSize: 8,
            marginTop: 10,
          }
        );
      }
      // ShipTo, SoldTo & DeliverTo Available
      else {
        displayWith = ['33%', '33%', '33%'];
        pdfHTML.content.push(
          {
            layout: 'noBorders',
            table: {
              widths: displayWith,
              body: [
                [{ text: 'SOLD TO: ' + soldToAccountDetails.accountNo, bold: true }, { text: 'SHIP TO: ' + cppOrder_i.accountNumber, bold: true }, { text: 'DELIVER TO: ' + deliverToAccountDetails.accountNo, bold: true }],
                [
                  soldToAccountDetails.accountName + ' \n' +
                  soldToAccountDetails.address1 + ' \n' +
                  (soldToAccountDetails.address2 == '' ? '' : soldToAccountDetails.address2 + ' \n') +
                  soldToAccountDetails.city + ', ' + soldToAccountDetails.state + ' ' + soldToAccountDetails.zipCode + ' \n',

                  cppOrder_i.accountName + ' \n' +
                  cppOrder_i.accountAddress1 + ' \n' +
                  cppOrder_i.accountCity + ', ' + cppOrder_i.accountState + ' ' + cppOrder_i.accountZipCode,

                  deliverToAccountDetails.accountName + ' \n' +
                  deliverToAccountDetails.address1 + ' \n' +
                  deliverToAccountDetails.city + ', ' + deliverToAccountDetails.state + ' ' + deliverToAccountDetails.zipCode + ' \n',
                ]
              ]
            },
            style: 'pageText',
            fontSize: 8,
            marginTop: 10,
          }
        );
      }
      // To show Disclaimer Message
      // pdfHTML.content.push(
      //  {
      //    alignment: 'center',
      //    table: {
      //      body: [
      //        ['Prices subject to change without notice.All Products(except inoculants) priced date of shipment & prices refresh daily.'],
      //      ]
      //    },
      //    layout: 'noBorders',
      //    fontSize: 8,
      //    color: '#6fc8c0',
      //    margin: [40, 5]
      //  }
      // )

      // To show table
      pdfHTML.content.push(
        this.getContractPdfObject(this.pdfDataObject.cppOrders[i].splitDetails)
      );

      pdfHTML.content.push(
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.cppOrders[i].placedByName + ' on ' + this.pdfDataObject.cppOrders[i].createdOnString
                + ' (CST). If you have any questions regarding this order please contact Winfield United Customer Service at 1-855-494-6343.'],
            ]
          },
          layout: 'noBorders'
        }
      );
      // To add logo and page Beak
      if (i + 1 !== this.pdfDataObject.cppOrders.length && this.pdfDataObject.cppOrders.length > 1) {
        pdfHTML.content.push(
          {
            style: 'pageBreak',
            image: 'data:image/png;base64,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',
            width: 102,
            height: 37,
            alignment: 'left',
          }
        );
      }
    }
    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    // var indexArr:number;
    // for(let i =0; i < this.pdfDataObject.cppOrders.length; i++){
    //   indexArr = i;
    // }
    const tblObject = [];
    let colum = [];
    const isRedirected: boolean = this.isRedirectedFromPlacedOrder;
    splitDetails.forEach(obj => {
      const cppOrderDetails = obj.productDetail;
      let jdeNumber = '';
      if (obj.jdeorderNumber) {
        jdeNumber = obj.jdeorderNumber;
      }
      if (isRedirected) {
        colum = [{
          text: 'Order ID: ' + this.pdfDataObject.cppOrders[this.ind].webOrderNumber.toString() + '-' + obj.splitId.toString(),
          alignment: 'left',
        },
        {
          text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
          alignment: 'right',
        }];
      }
      else if (jdeNumber == '') {
        colum = [{
          text: 'Order ID: ' + this.pdfDataObject.cppOrders[this.ind].webOrderNumber.toString() + '-' + obj.splitId.toString(),
          alignment: 'left',
        },
        {
          text: 'Status: ' + obj.orderStatus.toString(),
          alignment: 'left',
        },
        {
          text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
          alignment: 'right',
        }];
      }
      else {
        colum = [{
          text: 'Order ID: ' + this.pdfDataObject.cppOrders[this.ind].webOrderNumber.toString() + '-' + obj.splitId.toString(),
          alignment: 'left',
        },
        {
          text: 'Sales Order #: ' + jdeNumber,
          alignment: 'left',
        },
        {
          text: 'Status: ' + obj.orderStatus.toString(),
          alignment: 'left',
        },
        {
          text: 'Requested Arrival Date: ' + this.datePipe.transform(obj.productDetail[0].desiredDeliveryDate.toString(), 'MM/dd/yyyy'),
          alignment: 'right',
          width: '30%'
        }];
      }
      const tblHeader = [
        {
          style: 'pageText',
          widths: ['20%', '20%', '10%', '50%'],
          marginTop: 10,
          fontSize: 8,
          bold: true,
          columns: colum
        }
      ];

      tblObject.push(tblHeader);
      const tbl = {
        table: {
          widths: ['30%', '15%', '15%', '20%', '10%', '10%'],
          color: '#0b3f54',
          body: [
            [{
              text: 'Product',
              style: 'tableHeader'
            },
            {
              text: 'Ordered Quantity',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Ordering UOM',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Package Size',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Quote Price',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Pricing UOM',
              style: 'tableHeader', alignment: 'center'
            },
            ],
            ...cppOrderDetails.map(cpp => {
              var cellData = [],
                cellData = this.cppModifiedCellData(cpp);
              return [
                {
                  text: cellData
                },
                { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(4), alignment: 'center' },
                { text: cpp.uom, alignment: 'center' },
                { text: cpp.packageSize, alignment: 'center' },
                { text: (this.plAccess ? cpp.pricePerOrderUnit : 'N/A'), alignment: 'center' },
                { text: cpp.pricingUOM, alignment: 'center' },
              ];
            })
          ]
        },
        style: 'tablefont',
      };
      tblObject.push(tbl);
    });
    LolLoggerService.info(`tbl: ${tblObject}`);
    return tblObject;
  }

  // For your price and payment Term in the cell with style
  cppModifiedCellData(cpp) {
    const tempArray = [];
    if (cpp.itemVendorName) {
      tempArray.push(cpp.itemVendorName + ' \n' + cpp.itemDescription + '\n');
    }
    else {
      tempArray.push('' + cpp.itemDescription + '\n');
    }
    // if (this.plAccess && cpp.yourPrice != null && cpp.yourPrice != "" && cpp.yourPrice != undefined && cpp.yourPrice != 0) {
    //  tempArray.push({
    //    text: ('$' + cpp.yourPrice.toFixed(4) + '/' + cpp.pricingUOM + '\n'), style: 'tableUnit'
    //  })
    // }
    // if (this.plAccess && cpp.paymentTerms != null && cpp.paymentTerms != "" && cpp.paymentTerms != undefined) {
    //  tempArray.push({
    //    text: (cpp.paymentTerms.trim()), style: 'tablePayment'
    //  })
    // }

    return tempArray;
  }
}
